export function isComposerUnavailableError(error: unknown) {
  return (
    error instanceof Error &&
    /composer is not available/i.test(error.message)
  );
}

export function runIfComposerAvailable(action: () => void) {
  try {
    action();
    return true;
  } catch (error) {
    if (isComposerUnavailableError(error)) {
      return false;
    }

    throw error;
  }
}

export function isMessageEditAlreadyInProgressError(error: unknown) {
  return (
    error instanceof Error &&
    /edit already in progress/i.test(error.message)
  );
}

export function runIfMessageEditAvailable(action: () => void) {
  try {
    action();
    return true;
  } catch (error) {
    if (isMessageEditAlreadyInProgressError(error)) {
      return false;
    }

    throw error;
  }
}
